module.exports = __webpack_public_path__ + "img/APS.f2bcf7a6.svg";